var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShareBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "snsb8pvmta"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "xa2tr2otpb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#snsb8pvmta)",
    transform: "translate(-331.000000, -60.000000) translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#xa2tr2otpb)",
    transform: "translate(331.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    fillRule: "nonzero",
    d: "M13.437.375c1.723 0 3.12 1.398 3.12 3.122 0 1.722-1.397 3.12-3.12 3.12-.852 0-1.624-.342-2.187-.894L6.47 8.55c.095.3.147.619.147.95 0 .331-.052.65-.147.95l4.781 2.826c.563-.552 1.335-.893 2.186-.893 1.723 0 3.12 1.398 3.12 3.12 0 1.725-1.397 3.122-3.12 3.122-1.724 0-3.122-1.397-3.122-3.121 0-.331.052-.65.147-.95l-4.781-2.825c-.563.552-1.335.893-2.185.893-1.723 0-3.12-1.399-3.12-3.122 0-1.723 1.397-3.121 3.12-3.121.85 0 1.622.34 2.185.893l4.781-2.826c-.095-.3-.147-.618-.147-.949 0-1.724 1.398-3.122 3.122-3.122zm0 13.508c-.896 0-1.622.726-1.622 1.62 0 .896.726 1.622 1.622 1.622.895 0 1.62-.725 1.62-1.621 0-.895-.726-1.62-1.62-1.62zM3.496 7.88c-.895 0-1.62.726-1.62 1.62 0 .896.725 1.623 1.62 1.623.894 0 1.62-.727 1.62-1.622 0-.895-.726-1.621-1.62-1.621zm9.94-6.004c-.895 0-1.62.726-1.62 1.622 0 .894.725 1.62 1.62 1.62.895 0 1.621-.726 1.621-1.62 0-.896-.725-1.622-1.62-1.622z",
    transform: "translate(3.000000, 2.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareBlack);
export default __webpack_public_path__ + "static/media/ic_share_black.59a01ef1c77cf2ef83caf39b06da89fb.svg";
export { ForwardRef as ReactComponent };